module.exports = __webpack_public_path__ + "static/acupun_1_md-61b152008f6a84be2148ce1f12107406.webp";